import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Image from '../../../components/AppImage';

const EmployerRelationsTab = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const partnerships = [
  {
    id: 1,
    company: 'Tech Innovations Pvt Ltd',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1448e2f4d-1766615520167.png",
    logoAlt: 'Modern tech company office building with glass facade',
    status: 'Active',
    since: '2023-01-15',
    jobsPosted: 24,
    studentsHired: 45,
    upcomingDrives: 2,
    contactPerson: 'Mr. Rajesh Kumar',
    contactEmail: 'rajesh.kumar@techinnovations.com',
    contactPhone: '+91 98765 43210'
  },
  {
    id: 2,
    company: 'DataTech Solutions',
    logo: "https://images.unsplash.com/photo-1622380751376-6224be5656b7",
    logoAlt: 'Contemporary corporate building with geometric architecture',
    status: 'Active',
    since: '2022-08-20',
    jobsPosted: 18,
    studentsHired: 32,
    upcomingDrives: 1,
    contactPerson: 'Ms. Priya Sharma',
    contactEmail: 'priya.sharma@datatech.com',
    contactPhone: '+91 98765 43211'
  },
  {
    id: 3,
    company: 'Global Solutions India',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_177ecc407-1767383843539.png",
    logoAlt: 'Professional office workspace with modern furniture',
    status: 'Pending',
    since: '2026-01-28',
    jobsPosted: 0,
    studentsHired: 0,
    upcomingDrives: 0,
    contactPerson: 'Mr. Amit Patel',
    contactEmail: 'amit.patel@globalsolutions.in',
    contactPhone: '+91 98765 43212'
  }];


  const pendingApprovals = [
  {
    id: 1,
    company: 'Creative Solutions India',
    position: 'UI/UX Design Intern',
    type: 'Internship',
    stipend: '₹12,000/month',
    duration: '6 months',
    submittedDate: '2026-02-01',
    eligibility: 'B.Tech CSE/IT, CGPA > 7.5'
  },
  {
    id: 2,
    company: 'Tech Innovations Pvt Ltd',
    position: 'Full Stack Developer',
    type: 'Full Time',
    stipend: '₹6.5 LPA',
    duration: 'Permanent',
    submittedDate: '2026-02-02',
    eligibility: 'B.Tech CSE, CGPA > 8.0'
  }];


  const upcomingCampusDrives = [
  {
    id: 1,
    company: 'DataTech Solutions',
    date: '2026-02-10',
    time: '10:00 AM',
    venue: 'Auditorium Block A',
    positions: 'Data Analyst, Software Engineer',
    expectedStudents: 150,
    status: 'Confirmed'
  },
  {
    id: 2,
    company: 'Tech Innovations Pvt Ltd',
    date: '2026-02-15',
    time: '2:00 PM',
    venue: 'Conference Hall',
    positions: 'Frontend Developer, Backend Developer',
    expectedStudents: 120,
    status: 'Confirmed'
  }];


  const getStatusColor = (status) => {
    const colors = {
      'Active': 'bg-success/10 text-success border-success/20',
      'Pending': 'bg-warning/10 text-warning border-warning/20',
      'Inactive': 'bg-error/10 text-error border-error/20'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="text"
            placeholder="Search companies, contacts, or positions..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)} />

        </div>
        <Button variant="default" iconName="Building2">
          Add New Partnership
        </Button>
        <Button variant="outline" iconName="Calendar">
          Schedule Drive
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="bg-primary/5 rounded-lg p-4 border border-primary/20">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Active Partnerships</p>
              <p className="text-2xl font-bold text-primary">{partnerships?.filter((p) => p?.status === 'Active')?.length}</p>
            </div>
            <Icon name="Building2" size={32} color="var(--color-primary)" />
          </div>
        </div>
        <div className="bg-warning/5 rounded-lg p-4 border border-warning/20">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Pending Approvals</p>
              <p className="text-2xl font-bold text-warning">{pendingApprovals?.length}</p>
            </div>
            <Icon name="Clock" size={32} color="var(--color-warning)" />
          </div>
        </div>
        <div className="bg-success/5 rounded-lg p-4 border border-success/20">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Upcoming Drives</p>
              <p className="text-2xl font-bold text-success">{upcomingCampusDrives?.length}</p>
            </div>
            <Icon name="Calendar" size={32} color="var(--color-success)" />
          </div>
        </div>
      </div>

      <div className="bg-background rounded-lg p-6 border border-border">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">Active Partnerships</h3>
        <div className="space-y-4">
          {partnerships?.map((partner) =>
          <div key={partner?.id} className="p-4 rounded-lg border border-border hover:border-primary transition-smooth">
              <div className="flex flex-col lg:flex-row gap-4">
                <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted flex-shrink-0">
                  <Image
                  src={partner?.logo}
                  alt={partner?.logoAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h4 className="text-base font-medium text-foreground">{partner?.company}</h4>
                      <p className="text-sm text-muted-foreground">Partner since {new Date(partner?.since)?.toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })}</p>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(partner?.status)}`}>
                      {partner?.status}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
                    <div>
                      <p className="text-xs text-muted-foreground">Jobs Posted</p>
                      <p className="text-sm font-semibold text-foreground">{partner?.jobsPosted}</p>
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground">Students Hired</p>
                      <p className="text-sm font-semibold text-success">{partner?.studentsHired}</p>
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground">Upcoming Drives</p>
                      <p className="text-sm font-semibold text-foreground">{partner?.upcomingDrives}</p>
                    </div>
                    <div>
                      <p className="text-xs text-muted-foreground">Contact</p>
                      <p className="text-sm font-semibold text-foreground">{partner?.contactPerson}</p>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <Button variant="outline" size="sm" iconName="Mail">
                      Contact
                    </Button>
                    <Button variant="outline" size="sm" iconName="Calendar">
                      Schedule Drive
                    </Button>
                    <Button variant="outline" size="sm" iconName="FileText">
                      View Agreement
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-background rounded-lg p-6 border border-border">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-4">Pending Job Approvals</h3>
          <div className="space-y-3">
            {pendingApprovals?.map((job) =>
            <div key={job?.id} className="p-4 rounded-lg border border-warning/20 bg-warning/5">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="text-sm font-medium text-foreground">{job?.position}</h4>
                    <p className="text-xs text-muted-foreground">{job?.company}</p>
                  </div>
                  <span className="px-2 py-1 bg-warning/10 text-warning text-xs font-medium rounded">
                    {job?.type}
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-2 text-xs text-muted-foreground mb-3">
                  <div>Stipend: {job?.stipend}</div>
                  <div>Duration: {job?.duration}</div>
                  <div className="col-span-2">Eligibility: {job?.eligibility}</div>
                </div>
                <div className="flex gap-2">
                  <Button variant="success" size="sm" iconName="Check" className="flex-1">
                    Approve
                  </Button>
                  <Button variant="outline" size="sm" iconName="X" className="flex-1">
                    Reject
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="bg-background rounded-lg p-6 border border-border">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-4">Upcoming Campus Drives</h3>
          <div className="space-y-3">
            {upcomingCampusDrives?.map((drive) =>
            <div key={drive?.id} className="p-4 rounded-lg border border-border hover:border-primary transition-smooth">
                <div className="flex items-start justify-between mb-2">
                  <h4 className="text-sm font-medium text-foreground">{drive?.company}</h4>
                  <span className="px-2 py-1 bg-success/10 text-success text-xs font-medium rounded">
                    {drive?.status}
                  </span>
                </div>
                <div className="space-y-1 text-xs text-muted-foreground mb-3">
                  <div className="flex items-center gap-2">
                    <Icon name="Calendar" size={12} color="var(--color-muted-foreground)" />
                    <span>{new Date(drive?.date)?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })} at {drive?.time}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" />
                    <span>{drive?.venue}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Briefcase" size={12} color="var(--color-muted-foreground)" />
                    <span>{drive?.positions}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon name="Users" size={12} color="var(--color-muted-foreground)" />
                    <span>{drive?.expectedStudents} students expected</span>
                  </div>
                </div>
                <Button variant="outline" size="sm" iconName="ExternalLink" className="w-full">
                  View Details
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>);

};

export default EmployerRelationsTab;